import type { BlotterPreferencePayload } from 'apiConnector/blotters/blotterPreferenceStatePersistance';
import type { ColumnPreferenceState, IBlotterPreferenceState } from 'components/shared/Blotter/Grid/blotter.model';
import { emptyBlotterPreferences } from 'components/shared/Blotter/Grid/blotter.model';

export function toBlotterPreferences(response: BlotterPreferencePayload | undefined): IBlotterPreferenceState {
  if (!response || !response.data) {
    return emptyBlotterPreferences;
  }
  switch (response.version) {
    case 1:
      return fromLegacyV1(response.data as LegacyV1);
    case 2:
      return response.data as IBlotterPreferenceState;
    default:
      return emptyBlotterPreferences;
  }
}

function fromLegacyV1({ pageSizeState, columnState }: LegacyV1): IBlotterPreferenceState {
  const columns = columnState
    .sort((a, b) => (a.pivotIndex ?? 0) - (b.pivotIndex ?? 0))
    .map(({ colId, hide, width, pinned }) => ({ colId, hide, width, pinned }) as ColumnPreferenceState);
  return {
    pageSizeState: pageSizeState ?? 25,
    columnState: columns,
  };
}

type LegacyV1 = {
  pageSizeState: number | null | undefined;
  columnState: {
    colId: string;
    hide?: boolean;
    aggFunc: null;
    width?: number;
    pivotIndex?: number;
    pinned?: boolean | null;
    rowGroupIndex?: null;
  }[];
};
